import { SeverityType } from './Interface';

export const SEVERITY_TYPES = [SeverityType.CRITICAL, SeverityType.WARNING];

export const SEVERITY_BG_COLOR_MAP = {
  [SeverityType.CRITICAL]: 'bg-error',
  [SeverityType.WARNING]: 'bg-warning'
};
